/* eslint-disable no-loop-func */
import React, { PureComponent } from "react";
import styled from 'styled-components';
import { Loader } from 'react-loaders';
import moment from "moment";

import ErrorAlert from '../../components/alerts/error';
import DecisionsAlert from '../../components/alerts/decisions';
import Auth from "../../routes/Auth";

import {
  getRequest,
  putRequest,
  postRequest
} from "../../api/ApiService";

import RoundAdminTable from '../components/round-admin/table';

const Wrapper = styled.div`
  width: 100%;
  padding: 40px 40px 50px;
  background: #FAFAFA;

  .loader {
    display: inline-block;
    margin-top: 20px;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const LoaderWrapper = styled.div`
  width: 100%;
  padding: 40px 40px 50px;
`;

const TableWrapper = styled.div`
  background: #fff;
  border: 1px solid #D5D9DD;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  max-width: 880px;
`;

const PageTitle = styled.h1`
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  font-family: 'Mukta Vaani';
`;

const TableTitle = styled.h3`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  font-family: 'Mukta Vaani';
  color: rgba(0, 27, 59, 0.38);
  text-align: center;
`;

class RoundAdmin extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      rounds: [],
      changedRounds: [],
      defaultActiveRounds: [],
      showSuccess: false,
      successfullyChangedRoundNumber: 0,
      showError: false,
      errorTitle: '',
      errorMessage: '',
      startDateChanged: false,
      endDateChanged: false,
      loadingButtonRound: 0,
      roundsName: '',
    };
  }

  componentDidMount() {
    this.fetchRounds();
  }

  fetchRounds = async () => {
    getRequest(
      `${process.env.REACT_APP_API_URL}game/rounds`
    )
      .then(res => {
        let rounds = [];
        let showDefaultRounds = false;

        if (res.body.length) {
          rounds = res.body
            .map(i => ({
              id: i.id,
              number: i.number,
              start_date: moment(i.start_date),
              end_date: moment(i.end_date)
            }));
        } else {
          rounds = Array.from({ length: 3 }, (_, i) => ({
            id: i + 1,
            number: i + 1,
            start_date: moment().add(7 * i + 14 * i, 'days'),
            end_date: moment().add(7 * i + 14 * (i + 1), 'days')
          }));

          showDefaultRounds = true;
        }

        const roundWithLowestID = rounds.reduce((previous, current) => {
          return current.id < previous.id ? current : previous;
        });

        if (!showDefaultRounds) {
          getRequest(
            `${process.env.REACT_APP_API_URL}game/rounds/${roundWithLowestID.id}`
          )
            .then(res => {
              const roundsName = res.body.name ? res.body.name : 'Practice Game';

              this.setState({
                loaded: true,
                rounds,
                roundsName
              });
            })
            .catch(err => { });
        } else {
          const roundsName = 'Practice Game';
          this.setState({
            loaded: true,
            rounds,
            roundsName,
            defaultActiveRounds: [1, 2, 3]
          });
        }
      })
      .catch(err => { });
  }

  onChange = (datetime, round_id, field) => {
    if (typeof datetime === "string") {
      return;
    }

    let startDateChanged = false;
    let endDateChanged = false;

    if (field === 'start_date') {
      startDateChanged = true;
    } else if (field === 'end_date') {
      endDateChanged = true;
    }

    const { changedRounds } = this.state;

    let rounds = [...this.state.rounds];

    let index = rounds.findIndex(i => i.id === round_id);

    if (index >= 0 && field in rounds[index]) {
      rounds[index][field] = datetime;

      let newChangedRounds = [...changedRounds];
      if (!newChangedRounds.includes(round_id)) {
        newChangedRounds.push(round_id);
      }

      this.setState({
        rounds,
        changedRounds: newChangedRounds,
        startDateChanged,
        endDateChanged
      });
    }
  };

  onUpdate = round_id => {
    const {
      rounds,
      startDateChanged,
      endDateChanged,
      defaultActiveRounds
    } = this.state;
    const round = rounds.find(i => i.id === round_id);
    const prevRound = rounds.find(i => i.number === round.number - 1);
    const nextRound = rounds.find(i => i.number === round.number + 1);
    const currentDateTime = moment();
    let showError = false;
    let errorTitle = '';
    let errorMessage = '';

    if (round.end_date.isBefore(round.start_date)) {
      showError = true;
      errorTitle = 'Error | Start Time > End Time';
      errorMessage = 'The start date/time cannot be greater than the end date/time.';

      this.setState({
        showError,
        errorTitle,
        errorMessage
      });

      return;
    }

    if (nextRound && round.end_date.isAfter(nextRound.start_date)) {
      showError = true;
      errorTitle = 'Error | End Time > Next Round Start Time';
      errorMessage = 'The end date/time cannot be greater than the next round’s start date/time.';

      this.setState({
        showError,
        errorTitle,
        errorMessage
      });

      return;
    }

    if (prevRound && round.start_date.isBefore(prevRound.end_date)) {
      showError = true;
      errorTitle = 'Error | Start Time < Prior Round’s End Time';
      errorMessage = 'The start date/time cannot be earlier than the prior round’s end date/time.';

      this.setState({
        showError,
        errorTitle,
        errorMessage
      });

      return;
    }

    if (
      (startDateChanged && round.start_date.isBefore(currentDateTime))
      || (endDateChanged && round.end_date.isBefore(currentDateTime))
      || (defaultActiveRounds.find(i => i === round_id) && (round.start_date.isBefore(currentDateTime) || round.end_date.isBefore(currentDateTime)))
    ) {
      showError = true;
      errorTitle = 'Error | In the Past';
      errorMessage = 'The start or end date/time cannot be set in the past.';

      this.setState({
        showError,
        errorTitle,
        errorMessage
      });

      return;
    }

    if (Math.abs(round.start_date.diff(round.end_date, 'days')) > 30) {
      showError = true;
      errorTitle = 'Error | 30 Days Restriction';
      errorMessage = 'A round cannot be set 30 days or more.';

      this.setState({
        showError,
        errorTitle,
        errorMessage
      });
      return;
    }

    this.setState({
      loadingButtonRound: round_id
    });

    const { changedRounds } = this.state;
    const gameId = Auth.getGameId();

    const url = `${process.env.REACT_APP_API_URL}game/rounds/`;
    const request = defaultActiveRounds.find(i => i === round_id) ? postRequest(url) : putRequest(`${url}${round_id}/`);

    request.send({
      number: round.number,
      start_date: round.start_date,
      end_date: round.end_date,
      game: gameId
    })
      .then(res => {
        this.setState({
          loadingButtonRound: 0,
          changedRounds: changedRounds.filter(i => i !== round_id),
          defaultActiveRounds: defaultActiveRounds.filter(i => i !== round_id),
          showSuccess: true,
          successfullyChangedRoundNumber: round.number
        });
      })
      .catch(err => {
        this.setState({
          loadingButtonRound: 0,
        });

        if (
          err.response.status === 400 &&
          "non_field_errors" in err.response.body &&
          err.response.body["non_field_errors"].length > 0
        ) {
          this.setState({
            showError: true,
            errorTitle: 'Error | Server Error',
            errorMessage: err.response.body["non_field_errors"][0]
          });
        } else {
        }
      });
  };

  hideSuccessAlert = () => {
    this.setState({
      showSuccess: false
    });
  };

  hideErrorAlert = () => {
    this.setState({
      showError: false
    });
  };

  render() {
    const {
      loaded,
      rounds,
      changedRounds,
      showSuccess,
      successfullyChangedRoundNumber,
      showError,
      errorTitle,
      errorMessage,
      loadingButtonRound,
      roundsName,
      defaultActiveRounds
    } = this.state;
    return (
      <Wrapper>
        <PageTitle>Round Admin</PageTitle>
        {showError && (
          <ErrorAlert
            title={errorTitle}
            message={errorMessage}
            onHide={this.hideErrorAlert}
          />
        )}
        {showSuccess && (
          <DecisionsAlert
            type='success'
            title='Success!'
            message={`Round ${successfullyChangedRoundNumber} has been successfully updated!`}
            onHide={this.hideSuccessAlert}
          />
        )}
        <TableWrapper>
          <TableTitle>{roundsName}</TableTitle>
          {
            !loaded &&
            <LoaderWrapper>
              <Loader type="ball-scale-ripple" active />
            </LoaderWrapper>
          }
          {
            loaded &&
            <RoundAdminTable
              rounds={rounds}
              onChange={this.onChange}
              changedRounds={changedRounds}
              onUpdate={this.onUpdate}
              loadingButtonRound={loadingButtonRound}
              showOverlay={this.showOverlay}
              hideOverlay={this.hideOverlay}
              defaultActiveRounds={defaultActiveRounds}
            />
          }
        </TableWrapper>
      </Wrapper>
    );
  }
}

export default RoundAdmin;



// WEBPACK FOOTER //
// ./src/instructor/containers/round-admin.js